import React from 'react'

import exterior from './../../../UI/canvas/CarMenu/btns/exterior.svg'
import exteriorSelected from './../../../UI/canvas/CarMenu/btns/exterior-selected.svg'
import interior from './../../../UI/canvas/CarMenu/btns/interior.svg'
import interiorSelected from './../../../UI/canvas/CarMenu/btns/interior-selected.svg'

import back from './../../../UI/canvas/CarMenu/btns/back-btn.svg'

interface Props {
  isThreeActive: boolean,
  handleSelectedMenuElement: any,
  isInteror: any
}

interface State {
  currentVistaSelected: number,
}

class AccessoriesModuleTop extends React.Component<Props,State>{
  constructor(props: Props){
    super(props)
    this.state = {
      currentVistaSelected: 0,
    }
  }

  render(): React.ReactNode {
      return(
        <div className='accessories-module-mobile-top'>
          <div className='vista-btn-mobile' onClick={() =>  { this.state.currentVistaSelected === 1 ? this.setState({
              currentVistaSelected: 0
            }, () => {
              this.props.handleSelectedMenuElement(3,'customize',-1)
            })
            : this.props.handleSelectedMenuElement(-1,-1)
            } }>
            <img src={back} alt=''/>
            <div>Regresar</div>
          </div>
          <div 
          className={!(this.state.currentVistaSelected === 0) ? 'vista-btn-mobile':'vista-btn-mobile-selected'}
          onClick={() => {
            this.setState({
              currentVistaSelected: 0
            })
            this.props.handleSelectedMenuElement(3,'customize',-1)
          }}
          >
            <img src={!(this.state.currentVistaSelected === 0) ? exteriorSelected:exterior} alt=''/>
            <div>Exterior</div>
          </div>
          <div 
          className={!(this.state.currentVistaSelected === 1) ? 'vista-btn-mobile':'vista-btn-mobile-selected'}
          onClick={() => {
            this.setState({
              currentVistaSelected: 1
            })
            this.props.handleSelectedMenuElement(3,'customize',1)
          }}
          >
          <img src={!(this.state.currentVistaSelected === 1) ? interiorSelected:interior} alt=''/>
            <div>Interior</div>
          </div>
        </div>
      )
  }
}

export default AccessoriesModuleTop